import storage from '@/utils/storage'

// initial state
const state = ()=>({
  isLoading: false,
  theme: storage.get('theme') || 'white'
})
const getters = {
  isLoading: state => state.isLoading,
  theme: state => state.theme
}

// mutations
const mutations = {
  SET_THEME(state, payload){
    state.theme = payload
  },
  updateLoadingStatus(state, payload) {
    state.isLoading = payload.isLoading
  }
}

export default {
  namespaced:true,
  state,
  getters,
  mutations
}